module.exports = __webpack_public_path__ + "static/media/checkMark.2082ee3d.svg";